"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Network;
(function (Network) {
    Network["Mainnet"] = "mainnet";
    Network["Delphi"] = "delphinet";
    Network["Edo2Net"] = "edo2net";
    Network["Florence"] = "florencenet";
    Network["Granada"] = "granadanet";
    Network["Sandbox"] = "sandboxnet";
})(Network || (Network = {}));
exports.default = Network;
//# sourceMappingURL=network.js.map